var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _rect6, _rect7, _rect8, _polygon, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalk5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    fill: "#1c1530"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 52,
    width: 10,
    height: 54,
    fill: "#3a2458"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 52,
    width: 10,
    height: 54,
    fill: "#3a2458"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 47,
    width: 14,
    height: 6,
    fill: "#c09840",
    opacity: 0.65
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 47,
    width: 14,
    height: 6,
    fill: "#c09840",
    opacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 22,106 L 22,60 A 58,52 0 0,1 138,60 L 138,106",
    stroke: "#c09840",
    strokeWidth: 1.5,
    opacity: 0.6,
    fill: "#2a1840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 36,106 L 36,64 A 44,40 0 0,1 124,64 L 124,106",
    stroke: "#c09840",
    strokeWidth: 1,
    opacity: 0.5,
    fill: "#1c1530"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 50,106 L 50,70 A 30,28 0 0,1 110,70 L 110,106",
    stroke: "#5ab4ac",
    strokeWidth: 1,
    opacity: 0.55,
    fill: "#2a1840"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 64,106 L 64,77 A 16,16 0 0,1 96,77 L 96,106",
    stroke: "#5ab4ac",
    strokeWidth: 1,
    opacity: 0.6,
    fill: "#0f0c1a"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 84,
    rx: 10,
    ry: 9,
    fill: "#5ab4ac",
    opacity: 0.12
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 87,
    rx: 5,
    ry: 5,
    fill: "#c09840",
    opacity: 0.18
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 106,
    width: 148,
    height: 6,
    fill: "#3a2458"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 112,
    width: 156,
    height: 5,
    fill: "#2d1e48"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 6,
    width: 4,
    height: 42,
    fill: "#c09840",
    opacity: 0.25
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "80,4 85,16 80,13 75,16",
    fill: "#c09840",
    opacity: 0.75
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 0,
    width: 6,
    height: 6,
    fill: "#c05848",
    opacity: 0.85,
    transform: "rotate(45 80 3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk5);
export default __webpack_public_path__ + "static/media/talk5.1b292d37149d620f613c52138160fbd1.svg";
export { ForwardRef as ReactComponent };